/**
 * /shopping is the built-in catalog until a published site page replaces it.
 * A substitute whose own address is /shopping is rendered here. Any other
 * address redirects, so the header, product grids, and old links land on
 * the page the tenant built.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSite } from '../context/SiteContext';
import DynamicPage from './DynamicPage';
import Shop from './Shop';

function ShoppingPage() {
  const site = useSite();
  const replacement = site.replacements?.shopping;
  if (!replacement?.path) return <Shop />;
  if (replacement.path === '/shopping') return <DynamicPage slug="shopping" />;
  return <Navigate to={replacement.path} replace />;
}

export default ShoppingPage;
